export default "__VITE_PUBLIC_ASSET__847e7303__"